<template>
  <svg class="b-icon bi" xmlns='http://www.w3.org/2000/svg' fill="currentColor" width='1em' height='1em' viewBox='0 0 16 16' preserveAspectRatio='none'><g><path :opacity="ascOpacity" d='m8.0792.1584 3.9604 3.6436 3.802 3.4851h-15.6832l3.9604-3.4851z'/><path :opacity="descOpacity" d='m8.0792 16 3.9604-3.6436 3.802-3.4851h-15.6832l3.9604 3.4851z'/></g></svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SortIcon extends Vue {
  @Prop({ type: Boolean, default: false })
  sortDesc!: boolean

  @Prop({ type: Boolean, default: false })
  active!: boolean

  get ascOpacity () {
    if (!this.active || this.sortDesc) {
      return '0.3'
    }

    return '1'
  }

  get descOpacity () {
    if (!this.active || !this.sortDesc) {
      return '0.3'
    }

    return '1'
  }
}
</script>
